import * as Yup from "yup";
import { ERROR_MSG } from "../messages";

const hvidvask = (msg: string) =>
  Yup.string().when("harDuHaftHvidvasksager", {
    is: "ja",
    then: () => Yup.string().required(msg),
  });

export const TILSYN_FORM_VALIDATION_SCHEMA = Yup.object({
  // section 1
  forsikringSidstAar: Yup.string().required(ERROR_MSG.requiredRadio),
  nuvaerendeForsikringsselskab: Yup.object({
    id: Yup.string().required("Forsikringsselskab er påkrævet"),
    navn: Yup.string().required("Forsikringsselskabs navn er påkrævet"),
  }).required(ERROR_MSG.required),
  navnAndetForsikringsselskab: Yup.string().when(
    "nuvaerendeForsikringsselskab",
    {
      is: (value: any) => value?.id === "andet",
      then: () =>
        Yup.string()
          .required(ERROR_MSG.required)
          .max(30, "Navnet må højst være 30 tegn langt"),
    },
  ),
  nuvaerendeForsikringPolicenr: Yup.string().when(
    "nuvaerendeForsikringsselskab",
    {
      is: (value: any) => value?.id !== "ingen",
      then: () => Yup.string().required(ERROR_MSG.required),
    },
  ),

  // section 2
  ejerandeleIAndenVirksomhed: Yup.string().required(
    ERROR_MSG.requiredRadioYesNo,
  ),
  tilsynEjerandele: Yup.array().when("ejerandeleIAndenVirksomhed", {
    is: "ja",
    then: () => {
      return Yup.array(
        Yup.object({
          virksomhedensNavn: Yup.string().required(ERROR_MSG.required),
          andel: Yup.string().required(ERROR_MSG.required),
          "formaal-1": Yup.boolean(),
          "formaal-2": Yup.boolean(),
          "formaal-3": Yup.boolean(),
          "formaal-4": Yup.boolean(),
          "formaal-5": Yup.boolean(),
          "formaal-6": Yup.boolean(),
          "formaal-7": Yup.boolean(),
          "formaal-8": Yup.boolean(),
          "formaal-9": Yup.boolean(),
          "formaal-10": Yup.boolean(),
          "formaal-11": Yup.boolean(),
          "formaal-12": Yup.boolean(),
          "formaal-13": Yup.boolean(),
          "formaal-14": Yup.boolean(),
          "formaal-15": Yup.boolean(),
          "formaal-16": Yup.boolean(),
          "formaal-17": Yup.boolean(),
        }).test("formaalTest", ERROR_MSG.required, (obj) => {
          return Object.entries(obj).some(([key, value]) => {
            if (key.includes("formaal")) {
              if (value === true) {
                return true;
              }
            }
            return false;
          });
        }),
      ).required("Påkrævet");
    },
  }),

  // section 3
  harDuHaftForbrugersager: Yup.string().required(ERROR_MSG.requiredRadioYesNo),
  harDuHaftForbrugersagerUddyb: Yup.string().when("harDuHaftForbrugersager", {
    is: "ja",
    then: () => Yup.string().required(ERROR_MSG.required),
  }),
  harDuHaftStraffesager: Yup.string().required(ERROR_MSG.requiredRadioYesNo),

  // section 4
  harDuHaftHvidvasksager: Yup.string().required(ERROR_MSG.requiredRadioYesNo),

  // hvidvask sager = ja below
  hvorMangeSagerOmfattetAfHvidvaskloven: hvidvask(ERROR_MSG.requiredRadio),

  sagerKlientPolitiskEksponeret: hvidvask(ERROR_MSG.requiredRadio),
  "sagstype-1a": Yup.boolean(),
  "sagstype-1b": Yup.boolean(),
  "sagstype-2": Yup.boolean(),
  "sagstype-3": Yup.boolean(),
  "sagstype-4": Yup.boolean(),
  "sagstype-5": Yup.boolean(),
  "sagstype-6": Yup.boolean(),

  ...["1a", "1b", "2", "3", "4", "5", "6"].reduce(
    (acc, num) => ({
      ...acc,
      [`antalSagstyperHvidvaskloven-sagstype-${num}`]: Yup.string().when(
        `sagstype-${num}`,
        {
          is: true,
          then: () =>
            Yup.number()
              .typeError("Skal være et tal")
              .integer("Skal være et helt tal")
              .min(1, "Skal være mindst 1")
              .required(ERROR_MSG.required),
        },
      ),
    }),
    {},
  ),

  // !!! BEWARE !!!
  // the following property ONLY exists for validation purposes
  // it is NOT declared in the type for the form values
  hvilkeSagstyperHvidvaskloven: Yup.string().when("harDuHaftHvidvasksager", {
    is: "ja",
    then: () =>
      Yup.string().when(
        [
          "sagstype-1a",
          "sagstype-1b",
          "sagstype-2",
          "sagstype-3",
          "sagstype-4",
          "sagstype-5",
          "sagstype-6",
        ],
        {
          is: (...sagstypes) => !sagstypes.some(Boolean),
          then: () => Yup.string().required("Vælg mindst én sagstype"),
        },
      ),
  }),

  // 4.5
  sagerKompleksEllerUsaedvanlig: hvidvask(ERROR_MSG.requiredRadio),
  // 4.6
  sagerSkaerpedeKundekendskabsprocedurer: hvidvask(ERROR_MSG.requiredRadio),
  sagerLempedeKundekendskabsprocedurer: hvidvask(ERROR_MSG.requiredRadio),
  sagerUdenforEU: hvidvask(ERROR_MSG.required),
  sagerTransaktionHoejrisikotredjelande: hvidvask(ERROR_MSG.requiredRadio),
  sagerPaalagtFinansielSanktion: hvidvask(ERROR_MSG.requiredRadio),
  harDuBenyttetTredjemandEllerOutsourcingKundekendskabsprocedurer: hvidvask(
    ERROR_MSG.requiredRadio,
  ),
  harDuUnderrettetMistankeHvidvask: hvidvask(ERROR_MSG.requiredRadio),
  harDuUnderrettetMistankeFinansieringTerrorisme: hvidvask(
    ERROR_MSG.requiredRadio,
  ),
  // 4.14
  virksomhedRisikovurderingAdvokatvirksomhed: hvidvask(ERROR_MSG.requiredRadio),
  // 4.14a
  risikovurderingVirksomhedensForretningsmodel: Yup.string().when(
    "harDuHaftHvidvasksager",
    {
      is: "ja",
      then: () =>
        Yup.string().when("virksomhedRisikovurderingAdvokatvirksomhed", {
          is: "ja",
          then: () => Yup.string().required(ERROR_MSG.requiredRadioYesNo),
        }),
    },
  ),
  // 4.15
  advokatvirksomhedPolitikHvidvaskloven: Yup.string().when(
    "harDuHaftHvidvasksager",
    {
      is: "ja",
      then: () =>
        Yup.string().when("virksomhedRisikovurderingAdvokatvirksomhed", {
          is: (value: string) => value === "ja" || value === "nej",
          then: () => Yup.string().required(ERROR_MSG.requiredRadioYesNo),
        }),
    },
  ),
  // 4.15a
  virksomhedenForretningsmodelSagsomraaderPaatageSig: Yup.string().when(
    "harDuHaftHvidvasksager",
    {
      is: "ja",
      then: () =>
        Yup.string().when("virksomhedRisikovurderingAdvokatvirksomhed", {
          is: (value: string) => value === "ja" || value === "nej",
          then: () =>
            Yup.string().when("advokatvirksomhedPolitikHvidvaskloven", {
              is: "ja",
              then: () => Yup.string().required(ERROR_MSG.requiredRadioYesNo),
            }),
        }),
    },
  ),
  // 4.16
  advokatvirksomhedForretningsgangeHvidvaskloven: Yup.string().when(
    "harDuHaftHvidvasksager",
    {
      is: "ja",
      then: () =>
        Yup.string().when("virksomhedRisikovurderingAdvokatvirksomhed", {
          is: (value: string) => value === "ja" || value === "nej",
          then: () => Yup.string().required(ERROR_MSG.requiredRadioYesNo),
        }),
    },
  ),
});
